import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { TicketRequest } from '../model/ticket-access-request.model';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';
import { RenTM } from '../model/renTM.model';

@Injectable({
  providedIn: 'root'
})

export class RenTMService {

  constructor(private utilities: UtilitiesService, private http: HttpClient) { }

  requestRenTMAccess(body): Observable<GetAllResponse<RenTM>> {
    const url = environment.portalURL + API_URL.RENTM_REQUEST_URL;
    return this.utilities.req.httpPost<GetAllResponse<RenTM>>(url, body);
  }

  getRequestRenTMAccess(id): Observable<GetAllResponse<RenTM>> {
    const url = environment.portalURL + API_URL.RENTM_REQUEST_URL + `${id}`;
    return this.utilities.req.httpGet<GetAllResponse<RenTM>>(url);
  }

  getRequestRenTMAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.RENTM_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

}
